// Ad attribution + Meta Pixel helpers
const KEY = "lv_attribution";
const FIELDS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid"];

export const captureAttribution = () => {
  const params = new URLSearchParams(window.location.search);
  const found = {};
  FIELDS.forEach((f) => params.get(f) && (found[f] = params.get(f).slice(0, 150)));
  if (found.fbclid && !found.utm_source) found.utm_source = "facebook";
  if (Object.keys(found).length) sessionStorage.setItem(KEY, JSON.stringify(found));
};

export const getAttribution = () => {
  try {
    return JSON.parse(sessionStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
};

// No Meta Pixel events on the Facebook landing page (/glow), even if the pixel loaded earlier in the visit.
const onGlow = () => /^\/glow(\/|$)/.test(window.location.pathname);
const fbq = (...args) => !onGlow() && typeof window.fbq === "function" && window.fbq(...args);

// Meta Pixel: loaded on first visit to any page other than /glow (the Facebook landing page uses GTM only).
const PIXEL_ID = "1663918271749936";
export const initPixel = () => {
  if (onGlow() || window.fbq) return;
  const n = function pixel() { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
  window.fbq = n;
  if (!window._fbq) window._fbq = n;
  Object.assign(n, { push: n, loaded: true, version: "2.0", queue: [] });
  const s = document.createElement("script");
  s.async = true;
  s.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(s);
  window.fbq("init", PIXEL_ID);
};
const gtag = (...args) => typeof window.gtag === "function" && window.gtag(...args);

// Google Tag Manager container for the Facebook landing page (/glow). Loads once per visit.
const GTM_ID = "GTM-N9WKD3ZS";
export const loadGTM = () => {
  if (document.getElementById("gtm-script")) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
  if (typeof window.gtag !== "function") window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  const s = document.createElement("script");
  s.id = "gtm-script";
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(s);
};
const GA_ID = process.env.REACT_APP_GA4_ID;

// Google Analytics 4: loads only when a Measurement ID is configured.
export const initAnalytics = () => {
  if (!GA_ID || window.gtag) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtagShim() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false });
};

export const trackPageView = () => {
  fbq("track", "PageView");
  gtag("event", "page_view", { page_path: window.location.pathname, page_title: document.title });
};
export const trackLead = (data) => {
  fbq("track", "Lead", data);
  gtag("event", "generate_lead", { lead_source: data?.content_category, treatment: data?.content_name });
};
export const trackSchedule = () => {
  fbq("track", "Schedule");
  gtag("event", "book_now_click", { page_path: window.location.pathname });
};
export const trackBooked = () => {
  fbq("trackCustom", "BookingConfirmed");
  gtag("event", "booking_confirmed");
};
export const trackContact = () => {
  fbq("track", "Contact");
  gtag("event", "contact_click");
};
